module.exports = __webpack_public_path__ + "img/banner-feedback.4c58457c.png";